import * as React from 'react';

import {
  Grid,
  TextField,
  Button,
  Select,
  MenuItem,
  Checkbox,
  FormControlLabel,
} from '@mui/material';

// import { AxiosResponse } from 'axios';
import { sendContactForm, useIntersectionObserver } from './utils';

function ContactSection() {
  const [fullName, setFullName] = React.useState('');
  const [email, setEmail] = React.useState('');
  const [companyName, setCompanyName] = React.useState('');
  const [country, setCountry] = React.useState('');
  const [phoneNumber, setPhoneNumber] = React.useState('');
  const [jobTitle, setJobTitle] = React.useState('');
  const [lookingFor, setLookingFor] = React.useState('');
  const [comment, setComment] = React.useState('');
  const [hasConsent, setHasConsent] = React.useState(false);
  const [hasFormSuccessfullySent, setHasFormSuccessfullySent] = React.useState(false);
  const { isIntersecting, ref } = useIntersectionObserver();

  const [errors, setErrors] = React.useState({
    fullName: '',
    email: '',
    companyName: '',
    country: '',
    consent: '',
  });

  const validateEmail = (emailAddress: string): boolean => {
    const re = /\S+@\S+\.\S+/;

    return re.test(emailAddress);
  };

  const validateForm = (): boolean => {
    let newErrors = {
      fullName: fullName.trim() === '' ? 'Full name is required' : '',
      email:
        email.trim() === ''
          ? 'Email is required'
          : !validateEmail(email)
          ? 'Email is not valid'
          : '',
      companyName: companyName.trim() === '' ? 'Company name is required' : '',
      country: country.trim() === '' ? 'Country is required' : '',
      consent: !hasConsent ? 'Consent is required' : '',
    };

    setErrors(newErrors);

    return !Object.values(newErrors).some((error) => error !== '');
  };

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();

    if (!validateForm()) {
      return;
    } else {
      const formData = {
        fullName,
        email,
        companyName,
        country,
        phoneNumber,
        jobTitle,
        lookingFor,
        comment,
        hasConsent,
      };

      try {
        await sendContactForm(formData);

        setHasFormSuccessfullySent(true);
      } catch (error) {
        console.error('Error:', error);
      }
    }
  };

  return (
    <Grid
      container={true}
      spacing={3}
      justifyContent={'center'}
      className={'home-page__contact-container max-container'}
    >
      <Grid
        item={true}
        xs={10}
        md={5}
        lg={4}
        className="home-page__contact-container-header-box max-screen"
      >
        <div className={`fade-in-section ${isIntersecting ? 'is-visible' : ''}`} ref={ref}>
          <h1 data-qa="home-page__contact-container-header-box-title">Contact Us</h1>
        </div>
      </Grid>
      {!hasFormSuccessfullySent ? (
        <Grid item={true} xs={10} lg={8} className="home-page__contact-form-container">
          <form onSubmit={handleSubmit} className="home-page__contact-form-container-form">
            <Grid container={true} spacing={3} className="home-page__contact-form-container">
              <Grid item={true} xs={12} sm={6} className="home-page__contact-form-container-left">
                <TextField
                  label="Full Name"
                  value={fullName}
                  onChange={(e) => setFullName(e.target.value)}
                  error={!!errors.fullName}
                  helperText={errors.fullName}
                  required
                  className="contact-form-container-text-field"
                  InputProps={{
                    className: 'contact-form-container-text-field-inner',
                  }}
                  inputProps={{ 'data-qa': 'full-name' }}
                />
                <TextField
                  name="Email"
                  label="Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  error={!!errors.email}
                  helperText={errors.email}
                  required
                  className="contact-form-container-text-field"
                  InputProps={{
                    className: 'contact-form-container-text-field-inner',
                  }}
                  inputProps={{ 'data-qa': 'email' }}
                />
                <TextField
                  label="Company Name"
                  value={companyName}
                  onChange={(e) => setCompanyName(e.target.value)}
                  error={!!errors.companyName}
                  helperText={errors.companyName}
                  required
                  className="contact-form-container-text-field"
                  InputProps={{
                    className: 'contact-form-container-text-field-inner',
                  }}
                  inputProps={{ 'data-qa': 'company-name' }}
                />
                <TextField
                  label="Country"
                  value={country}
                  onChange={(e) => setCountry(e.target.value)}
                  error={!!errors.country}
                  helperText={errors.country}
                  required
                  className="contact-form-container-text-field"
                  InputProps={{
                    className: 'contact-form-container-text-field-inner',
                  }}
                  inputProps={{ 'data-qa': 'country' }}
                />
                <TextField
                  label="Phone Number"
                  value={phoneNumber}
                  onChange={(e) => setPhoneNumber(e.target.value)}
                  className="contact-form-container-text-field"
                  InputProps={{
                    className: 'contact-form-container-text-field-inner',
                  }}
                />
                <TextField
                  label="Job Title"
                  value={jobTitle}
                  onChange={(e) => setJobTitle(e.target.value)}
                  className="contact-form-container-text-field"
                  InputProps={{
                    className: 'contact-form-container-text-field-inner',
                  }}
                />
                <Select
                  label="I am looking for"
                  value={lookingFor}
                  onChange={(e) => setLookingFor(e.target.value)}
                  className="contact-form-container-select-box"
                  displayEmpty
                >
                  <MenuItem value="" disabled>
                    I am looking for
                  </MenuItem>
                  <MenuItem value="gameDevelopment">Developer Support</MenuItem>
                  <MenuItem value="publishing">Media Inquiry</MenuItem>
                  <MenuItem value="technology">Business Partnership</MenuItem>
                  <MenuItem value="technology">Other</MenuItem>
                </Select>
              </Grid>
              <Grid item={true} xs={12} sm={6} className="home-page__contact-form-container-right">
                <textarea
                  aria-label="Comment"
                  value={comment}
                  onChange={(e) => setComment(e.target.value)}
                  placeholder="YOUR COMMENT"
                  className="contact-form-container-text-area"
                />
              </Grid>
              <Grid item={true} xs={12} className="home-page__contact-form-container-bottom">
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={hasConsent}
                      onChange={(e) => setHasConsent(e.target.checked)}
                      style={{ background: errors.consent ? 'rgba(234,4,73,0.2)' : undefined }}
                      data-qa="consent-box"
                    />
                  }
                  label="I consent to be contacted by Skillz"
                  className="contact-form-container-check-box"
                />
                <Button type="submit" className="contact-form-container-button">
                  Submit
                </Button>
              </Grid>
            </Grid>
          </form>
        </Grid>
      ) : (
        <Grid item={true} xs={10} lg={8} className="home-page__contact-form-submitted-container">
          <p>
            Thank you for reaching out to Skillz. We have received your request and will reach back
            out soon. Have a wonderful day!
          </p>
        </Grid>
      )}
    </Grid>
  );
}

export { ContactSection };
